import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import GroundTruthEnableQuestion from './GroundTruthEnableQuestion';

const GroundTruthArbitraryString = ({
  question,
  setScore,
  currentMinimumScore,
  currentMaximumScore,
  hideMinimumScore,
  disabled,
  sectionId,
  questionId,
}) => (
  <div
    style={{
      margin: 5,
      marginBottom: 40,
    }}
  >
    <hr />
    <span className="f6 fw9">*ArbitraryString</span>
    <div className="pa2 bg-light-gray flex nowrap">
      <h2 className="f4 fw3 ma0 ws-initial">
        {question}
        &nbsp;
      </h2>
      <h2 className="black f5"><FormattedMessage id="groundtruthview.evaluationInReview" /></h2>
    </div>
    <GroundTruthEnableQuestion
      onChange={setScore}
      currentMinimumScore={currentMinimumScore}
      currentMaximumScore={currentMaximumScore}
      hideMinimumScore={hideMinimumScore}
      disabled={disabled}
      sectionId={sectionId}
      questionId={questionId}
    />
  </div>
);

GroundTruthArbitraryString.defaultProps = {
  currentMinimumScore: undefined,
  currentMaximumScore: undefined,
  hideMinimumScore: true,
  disabled: false,
};

GroundTruthArbitraryString.propTypes = {
  question: PropTypes.string.isRequired,
  setScore: PropTypes.func.isRequired,
  currentMinimumScore: PropTypes.number,
  currentMaximumScore: PropTypes.number,
  hideMinimumScore: PropTypes.bool,
  disabled: PropTypes.bool,
  sectionId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  questionId: PropTypes.number.isRequired,
};

export default GroundTruthArbitraryString;
